<template>
    <module-card :nextFunction="unlockResources">
        <v-img class="mx-auto" :max-width="300" :src="require('@/assets/GoinDownhillFast/alcoholMJ.png')" alt="Alcohol and Marijuana"></v-img>
        <p class="text-subtitle-2 font-weight-bold text-center">Alcohol and Marijuana (also known as Pot, Weed, Herb)</p>
        <p>
            Some people say that they are “more aware” when they drink or smoke weed – but this can make you forgetful and lose motivation to stick to your goals. That’s why alcohol and marijuana (pot) are thought of as “depressants” – a
            fancy way of saying they slow down a person’s body and brain. Some people say they use depressants to feel relaxed. This is especially true when people use them to deal with hard feelings like anger, frustration, or sadness.
        </p>
        <p>
            <external-link href="https://teens.drugabuse.gov/drug-facts/alcohol" target="_blank">Click here to learn about alcohol</external-link> and
            <external-link href="https://teens.drugabuse.gov/drug-facts/marijuana" target="_blank">here to learn about marijuana</external-link>
        </p>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { forEach } from 'lodash';

    export default {
        computed: {
            resources: sync('resources')
        },
        methods: {
            unlockResources() {
                // unlock alcohol and marijuana resources
                forEach(this.resources, (o) => {
                    if (o.category === 'Drugs and Alcohol' && (o.topic === 'Alcohol' || o.topic === 'Marijuana')) {
                        o.unlocked = true;
                    }
                });
            }
        }
    };
</script>
